import { SharedObject } from '../../grey-shared-object';

export default new SharedObject();


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/sharedObject/index.ts